// extracted by mini-css-extract-plugin
export var childrenContainer = "_1c-0";
export var virtualScrollArea = "_1c-1";